import React, { useState } from 'react';
import { Sidebar, NavRoute } from './Sidebar';
import { TopBar } from './TopBar';
import { StatusBar } from './StatusBar';
import { QuickCreateModal } from '../../modules/dashboard/QuickCreateModal';

interface AppShellProps {
  currentRoute: NavRoute;
  onRouteChange: (route: NavRoute) => void;
  children: React.ReactNode;
}

export const AppShell: React.FC<AppShellProps> = ({
  currentRoute,
  onRouteChange,
  children,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isQuickCreateOpen, setIsQuickCreateOpen] = useState(false);

  // Close sidebar drawer on Escape key press
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isSidebarOpen) {
        setIsSidebarOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isSidebarOpen]);

  return (
    <div className="app-container">
      {/* Backdrop overlay for navigation drawer */}
      {isSidebarOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar Navigation Drawer */}
      <Sidebar
        currentRoute={currentRoute}
        onRouteChange={(route) => {
          onRouteChange(route);
          setIsSidebarOpen(false);
        }}
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />

      {/* Main App Canvas */}
      <div className="app-main">
        <TopBar
          currentRoute={currentRoute}
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
          onOpenQuickCreate={() => setIsQuickCreateOpen(true)}
        />

        <main className="workspace-content">
          {children}
        </main>

        <StatusBar />
      </div>

      {/* Quick Document Creation Modal */}
      <QuickCreateModal
        isOpen={isQuickCreateOpen}
        onClose={() => setIsQuickCreateOpen(false)}
        onSelectType={(route) => {
          onRouteChange(route);
          setIsQuickCreateOpen(false);
        }}
      />
    </div>
  );
};
